import { useTranslation } from "react-i18next";
import React, { useContext } from "react";
import ClientCard from "./ClientCard";

import LibertyIMG from "../../assets/app/ClientSection/LibertyExpress.png";
import pannaIMG from "../../assets/app/ClientSection/PANNA.png";
import therapyIMG from "../../assets/app/ClientSection/THERAPY.png";
import urbeIMG from "../../assets/app/ClientSection/URBE-MIAMI.png";
import temuIMG from "../../assets/app/ClientSection/temu.png";
import LaEstanciaArgentinaIMG from "../../assets/app/ClientSection/LaEstanciaArgentina.png";
import PlusUSAIMG from "../../assets/app/ClientSection/PlusUSA.png";
import EliosOpticalIMG from "../../assets/app/ClientSection/Elios.png";
import tekenoIMG from "../../assets/app/ClientSection/TEKENO.png";
import TuAgenteVirtualIMG from "../../assets/app/Nav/LOGO-FONDO-NEGRO.png";
import InternationalCarsIMG from "../../assets/app/ClientSection/CarsUSA.png";
import RealWiseIMG from "../../assets/app/ClientSection/RealWise.png";
import KrakenCourierIMG from "../../assets/app/ClientSection/Kraken.png";

import "../../styles/app/TestimonySection.css";
import "../../styles/app/ClientSection.css";
import { ThemeContext } from "../../contexts/ThemeContext";

const ClientSection: React.FC = () => {
  const { t } = useTranslation();

  const themeContext = useContext(ThemeContext);

  if (!themeContext) {
    throw new Error("ThemeContext must be used within a ThemeProvider");
  }

  const { isLightMode } = themeContext;

  const clients = [
    {
      alt: "LibertyExpress",
      src: LibertyIMG,
      tooltip: {
        objective: t("testimonySection.testimonials.0.objective"),
        results: [
          t("testimonySection.testimonials.0.results.0"),
          t("testimonySection.testimonials.0.results.1"),
          t("testimonySection.testimonials.0.results.2"),
          t("testimonySection.testimonials.0.results.3"),
          t("testimonySection.testimonials.0.results.4"),
          t("testimonySection.testimonials.0.results.5"),
        ],
        phoneNumber: "+1 786.485-0731",
        tag: t("clientSection.shipping"),
      },
      roundType: 1,
      styleType: "black",
    },
    {
      alt: "PANNA",
      src: pannaIMG,
      tooltip: {
        objective: t("testimonySection.testimonials.1.objective"),
        results: [
          t("testimonySection.testimonials.1.results.0"),
          t("testimonySection.testimonials.1.results.1"),
          t("testimonySection.testimonials.1.results.2"),
          t("testimonySection.testimonials.1.results.3"),
          t("testimonySection.testimonials.1.results.4"),
          t("testimonySection.testimonials.1.results.5"),
        ],
        phoneNumber: "+1 202.831-2400",
        tag: t("clientSection.restaurant"),
      },
      roundType: 2,
      styleType: "gradient",
    },
    {
      alt: "THERAPY",
      src: therapyIMG,
      tooltip: {
        objective: t("testimonySection.testimonials.4.objective"),
        results: [
          t("testimonySection.testimonials.4.results.0"),
          t("testimonySection.testimonials.4.results.1"),
          t("testimonySection.testimonials.4.results.2"),
          t("testimonySection.testimonials.4.results.3"),
          t("testimonySection.testimonials.4.results.4"),
          t("testimonySection.testimonials.4.results.5"),
        ],
        phoneNumber: "+1 786.765-4651",
        tag: t("clientSection.therapy"),
      },
      roundType: 1,
      styleType: "black",
    },
    {
      alt: "UrbeMIAMI",
      src: urbeIMG,
      tooltip: {
        objective: t("testimonySection.testimonials.2.objective"),
        results: [
          t("testimonySection.testimonials.2.results.0"),
          t("testimonySection.testimonials.2.results.1"),
          t("testimonySection.testimonials.2.results.2"),
          t("testimonySection.testimonials.2.results.3"),
          t("testimonySection.testimonials.2.results.4"),
          t("testimonySection.testimonials.2.results.5"),
        ],
        phoneNumber: "+1 786.949-2143",
        tag: t("clientSection.realEstate"),
      },
      roundType: 1,
      styleType: "gradient",
    },
    {
      alt: "TEMU",
      src: temuIMG,
      tooltip: {
        objective: t("testimonySection.testimonials.3.objective"),
        results: [
          t("testimonySection.testimonials.3.results.0"),
          t("testimonySection.testimonials.3.results.1"),
          t("testimonySection.testimonials.3.results.2"),
          t("testimonySection.testimonials.3.results.3"),
          t("testimonySection.testimonials.3.results.4"),
          t("testimonySection.testimonials.3.results.5"),
        ],
        phoneNumber: "+1 754.256-4190",
        tag: t("clientSection.shipping"),
      },
      roundType: 2,
      styleType: "black",
    },
    {
      alt: "TuAgenteVirtual",
      src: TuAgenteVirtualIMG,
      tooltip: {
        objective: t("testimonySection.testimonials.7.objective"),
        results: [
          t("testimonySection.testimonials.7.results.0"),
          t("testimonySection.testimonials.7.results.1"),
          t("testimonySection.testimonials.7.results.2"),
          t("testimonySection.testimonials.7.results.3"),
          t("testimonySection.testimonials.7.results.4"),
          t("testimonySection.testimonials.7.results.5"),
        ],
        phoneNumber: "+1 786 244-8828",
        tag: t("clientSection.aiSolutions"),
      },
      roundType: 2,
      styleType: "black",
    },
    {
      alt: "PlusUSA",
      src: PlusUSAIMG,
      tooltip: {
        objective: t("testimonySection.testimonials.8.objective"),
        results: [
          t("testimonySection.testimonials.8.results.0"),
          t("testimonySection.testimonials.8.results.1"),
          t("testimonySection.testimonials.8.results.2"),
          t("testimonySection.testimonials.8.results.3"),
          t("testimonySection.testimonials.8.results.4"),
          t("testimonySection.testimonials.8.results.5"),
        ],
        phoneNumber: "+1 786 946-0026",
        tag: t("clientSection.shipping"),
      },
      roundType: 1,
      styleType: "black",
    },
    {
      alt: "LaEstanciaArgentina",
      src: LaEstanciaArgentinaIMG,
      tooltip: {
        objective: t("testimonySection.testimonials.6.objective"),
        results: [
          t("testimonySection.testimonials.6.results.0"),
          t("testimonySection.testimonials.6.results.1"),
          t("testimonySection.testimonials.6.results.2"),
          t("testimonySection.testimonials.6.results.3"),
          t("testimonySection.testimonials.6.results.4"),
          t("testimonySection.testimonials.6.results.5"),
        ],
        phoneNumber: "+1 786 565-6521",
        tag: t("clientSection.restaurant"),
      },
      roundType: 1,
      styleType: "gradient",
    },
    {
      alt: "EliosOptical",
      src: EliosOpticalIMG,
      tooltip: {
        objective: t("testimonySection.testimonials.9.objective"),
        results: [
          t("testimonySection.testimonials.9.results.0"),
          t("testimonySection.testimonials.9.results.1"),
          t("testimonySection.testimonials.9.results.2"),
          t("testimonySection.testimonials.9.results.3"),
          t("testimonySection.testimonials.9.results.4"),
          t("testimonySection.testimonials.9.results.5"),
        ],
        phoneNumber: "+1 786 755-3266", // No phone number found
        tag: t("clientSection.health"),
      },
      roundType: 2,
      styleType: "gradient",
    },
    {
      alt: "International Cars USA Corp",
      src: InternationalCarsIMG,
      tooltip: {
        objective: t("testimonySection.testimonials.10.objective"),
        results: [
          t("testimonySection.testimonials.10.results.0"),
          t("testimonySection.testimonials.10.results.1"),
          t("testimonySection.testimonials.10.results.2"),
          t("testimonySection.testimonials.10.results.3"),
          t("testimonySection.testimonials.10.results.4"),
          t("testimonySection.testimonials.10.results.5"),
        ],
        phoneNumber: "+1 786 838-0122",
        tag: t("clientSection.automotive"),
      },
      roundType: 1,
      styleType: "black",
    },
    {
      alt: "RealWise, LLC",
      src: RealWiseIMG,
      tooltip: {
        objective: t("testimonySection.testimonials.11.objective"),
        results: [
          t("testimonySection.testimonials.11.results.0"),
          t("testimonySection.testimonials.11.results.1"),
          t("testimonySection.testimonials.11.results.2"),
          t("testimonySection.testimonials.11.results.3"),
          t("testimonySection.testimonials.11.results.4"),
          t("testimonySection.testimonials.11.results.5"),
        ],
        phoneNumber: "+1 754 335-4312",
        tag: t("clientSection.realEstate"),
      },
      roundType: 2,
      styleType: "gradient",
    },
    {
      alt: "Kraken Courier",
      src: KrakenCourierIMG,
      tooltip: {
        objective: t("testimonySection.testimonials.12.objective"),
        results: [
          t("testimonySection.testimonials.12.results.0"),
          t("testimonySection.testimonials.12.results.1"),
          t("testimonySection.testimonials.12.results.2"),
          t("testimonySection.testimonials.12.results.3"),
          t("testimonySection.testimonials.12.results.4"),
          t("testimonySection.testimonials.12.results.5"),
        ],
        phoneNumber: "+1 786 675-6551", // Placeholder phone number
        tag: t("clientSection.shipping"),
      },
      roundType: 1,
      styleType: "black",
    },
    /*
    {
      alt: "TEKENO",
      src: tekenoIMG,
      tooltip: {
        objective: t("testimonySection.testimonials.5.objective"),
        results: [
          t("testimonySection.testimonials.5.results.0"),
          t("testimonySection.testimonials.5.results.1"),
          t("testimonySection.testimonials.5.results.2"),
          t("testimonySection.testimonials.5.results.3"),
          t("testimonySection.testimonials.5.results.4"),
          t("testimonySection.testimonials.5.results.5"),
        ],
        phoneNumber: "+1 786 963-4488",
        tag: t("clientSection.marketplace"),
      },
      roundType: 2,
      styleType: "gradient",
    },
    */
  ];
  return (
    <section
      className="client-section"
      data-theme={isLightMode ? "light" : "dark"}
    >
      <div className="client-heading">
        <h2 className="client-title">{t("testimonySection.title")}</h2>
        <p className="client-desc">{t("testimonySection.description")}</p>
      </div>
      <div className="client-grid">
        {clients.map((client, index) => (
          <ClientCard
            key={index}
            alt={client.alt}
            src={client.src}
            tooltip={client.tooltip}
            roundType={client.roundType as 1 | 2}
            styleType={client.styleType as "black" | "gradient"}
          />
        ))}
      </div>
    </section>
  );
};

export default ClientSection;
